import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/bpa`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioQuantitativoProducao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-quantitativo-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioBpaIndividualizado(queryParms) {

            return repository.get(`${baseUrl}/relatorio-bpa-individualizado?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioBpaConsolidado(queryParms) {

            return repository.get(`${baseUrl}/relatorio-bpa-consolidado?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
